module.exports = __webpack_public_path__ + "static/news6.png";